import {AuthDTO} from './authDTO';

export class TransactionDTO {
   tenantID: string;
   username: string;
   fromDate: Date;
   toDate: Date;
   auth: AuthDTO;
}
